#import "./related-lead-fragment.graphql"
#import "../../../activity-ai/graphql/fragments/zoom-meeting-timeline-fragment.graphql"

fragment ActivityFragment on Activity {
    id
    name
    isMediaLogged
    activityType {
        id
        name
    }
    logNote {
        id
        bodyHtml
    }
    participants {
        id
        name
        avatarUrl
        initials
        htmlUrl
    }
    relatedLeads {
        id
        name
        ... on Lead {
            ...RelatedLeadFragment
        }
    }
    externalMeeting {
        ...ZoomMeetingTimelineFragment
    }
}
